/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// PrimeNG
import { ToastModule } from 'primeng/toast';

// Bulb
import { TranslocoModule } from '@jsverse/transloco';
import { AeroModule } from '../../aero/aero.module';

import { LaunchButtonComponent } from './launch-button/launch-button.component';
import { MobileLaunchToastComponent } from './mobile-launch-toast/mobile-launch-toast.component';
import { BulbMobileLauncherTranslationProvider } from './translation-provider';
import { WindowProvider } from '../../common/services/window.service';

@NgModule({
  declarations: [
    LaunchButtonComponent,
    MobileLaunchToastComponent,
  ],
  imports: [
    // Angular
    CommonModule,

    // PrimeNG
    ToastModule,

    // Bulb
    AeroModule,

    TranslocoModule,
  ],

  providers: [
    BulbMobileLauncherTranslationProvider,
    WindowProvider,
  ],
  exports: [
    LaunchButtonComponent,
  ],
})
export class MobileLauncherModule { }
